import axios from 'axios'
import * as utils from '@/mixins/utils'

export default() => {	
	return axios.create({
		baseURL: process.env.DECON_API,
		withCredentials: false,
        headers: utils.authHeader()
    })
}


// WEBPACK FOOTER //
// ./src/api/Api.js